export const en = {
    add_companion: 'Add a companion',
    agreement: 'By clicking the "Save" button, you accept',
    agreement_name: 'consent to the transfer of personal data',
    contact_info: 'Contact information',
    contact_info_for: 'Needed for business trip communication and taxi registration',
    main_info: 'Main information',
    main_info_for: 'Needed for business trips',
};
